
/**
 * params required
 * idperson
 */
import { defineComponent, onMounted, ref, inject, watch } from 'vue'

//components
import btnDownload from "@/components/buttons/btnDownload.vue"
import UploadFileModal from '@/components/modals/general/UploadFileModal.vue';

//service
import personService from "@/core/services/PersonService"
import { errManager, mbtoa } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
export default defineComponent({
    props:{
        idperson: {
            type: String,
            required: true,
            default: ""
        }
    },
    components:{
        btnDownload, UploadFileModal
    },
    setup(props) {
        const { t } = useI18n();
        const loader = ref(false)
        const urlServerFile = ref(process.env.VUE_APP_REPO);
        const photo = ref( < any > {});
        const photoList = ref<any>([])
        const paramsUpload = ref<any>({});
        const uploadPhotoRef = ref<any>(null);
        //variables globales de foto
        //const action = inject<any>('action')
        //const gblPhoto = inject<any>('gblPhoto')
        //const dialogPhoto = inject<any>('dialogPhoto')
        //const gblDataPhoto = inject<any>('gblDataPhoto')

        //events
        const getPhoto = async () => {
            loader.value = true;
            photo.value = {};
            photoList.value.length = 0;
            await personService
                .getPhoto({
                    idperson: props.idperson, all: true
                })
                .then((res) => {
                    photoList.value = res.data;
                    if(photoList.value.length > 0) {Object.assign(photo.value, photoList.value[0])}
                    loader.value = false;
                })
                .catch(({ response}) => {
                    loader.value = false;
                    errManager(response, null, 2)
                });
        };

        const handleCurrentChange = (val: object  | undefined) => {
            Object.assign(photo.value, val)
        }

        const onDialogPhoto = () => {
            if(uploadPhotoRef.value){
                paramsUpload.value.id = btoa(props.idperson);
                paramsUpload.value.alias    = 'AVATAR';
                paramsUpload.value.folder   = 'fotos';
                paramsUpload.value.destiny  = 'photo'; 
                uploadPhotoRef.value.openModal();
            } 
        };
        
        const uploadResponse = (data: any) => {
            if(data.status == 'success') getPhoto();
        }

        //watch(() => gblPhoto.value, getPhoto);

        onMounted(()=>{
            getPhoto()
        })

        return {
            t,
            //action,
            urlServerFile,
            //gblPhoto,
            mbtoa,
            loader,
            photo,
            photoList,
            handleCurrentChange,
            //dialogPhoto,
            onDialogPhoto,
            paramsUpload,
            uploadPhotoRef,
            //events
            uploadResponse
        }

    },
})
